// extracted by mini-css-extract-plugin
module.exports = {"img":"Image_img__6wh2j","showImage":"Image_showImage__3Ia2r","hideImage":"Image_hideImage__2hFhU"};